import { JSX, SVGProps } from 'react';

export const Vercel = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg width={800} height={800} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" d="m256 48 240 416H16Z" />
  </svg>
);
